import { Navigate } from "react-router-dom";
import { isUser } from "../utils/AuthSession"

export default function UserPage(props) {
    if (isUser()) {
        return (<>{props.children}</>)
    } else {
        return (<Navigate to='/login' />);
    }
}